import { useEffect, useState } from "react";
import { adminApi } from "@/admin/AdminAuthContext";
import AdminPageShell from "@/admin/AdminPageShell";
import { Save } from "lucide-react";

const FIELD_GROUPS = [
  { title: "Contact Placeholders", fields: [
    { key: "contact_phone", label: "Phone" },
    { key: "contact_email", label: "Email" },
    { key: "contact_whatsapp", label: "WhatsApp (digits only, with country code)" },
    { key: "office_address", label: "Office Address" },
    { key: "google_maps_embed_url", label: "Google Maps Embed URL" },
  ]},
  { title: "SEO & Analytics (fill in before launch)", fields: [
    { key: "gtm_container_id", label: "GTM Container ID" },
    { key: "meta_pixel_id", label: "Meta Pixel ID" },
    { key: "linkedin_insight_tag_id", label: "LinkedIn Insight Tag ID" },
    { key: "microsoft_clarity_id", label: "Microsoft Clarity ID" },
  ]},
  { title: "Newsletter Provider (connect before deployment)", fields: [
    { key: "newsletter_provider", label: "Provider (e.g. mailchimp, sendgrid)" },
  ]},
];

const AdminSettings = () => {
  const [settings, setSettings] = useState({});
  const [loading, setLoading] = useState(true);
  const [saved, setSaved] = useState(false);

  useEffect(() => { adminApi.get("/settings").then((res) => setSettings(res.data)).finally(() => setLoading(false)); }, []);

  const save = async (e) => {
    e.preventDefault();
    await adminApi.put("/settings", settings);
    setSaved(true);
    setTimeout(() => setSaved(false), 2500);
  };

  if (loading) return <p className="text-small">Loading…</p>;

  return (
    <AdminPageShell title="Settings" description="Site-wide contact placeholders and SEO/analytics configuration." testId="admin-settings-page">
      <form onSubmit={save} className="space-y-8">
        <div className="neu-panel p-6">
          <span className="eyebrow block mb-3">Google Analytics (GA4)</span>
          <p className="text-small">
            The Google tag (gtag.js, ID <code>G-6E6HE98HQ5</code>) is installed as a permanent,
            fixed snippet directly in the site's HTML &mdash; not configurable here &mdash; so
            every page carries exactly one Google tag with no risk of accidental duplication.
          </p>
        </div>
        {FIELD_GROUPS.map((group) => (
          <div key={group.title} className="neu-panel p-6">
            <span className="eyebrow block mb-5">{group.title}</span>
            <div className="grid sm:grid-cols-2 gap-4">
              {group.fields.map((f) => (
                <div key={f.key}>
                  <label className="text-small block mb-1">{f.label}</label>
                  <input
                    value={settings[f.key] || ""}
                    onChange={(e) => setSettings({ ...settings, [f.key]: e.target.value })}
                    className="neu-inset w-full h-11 px-3"
                    data-testid={`admin-setting-${f.key}`}
                  />
                </div>
              ))}
            </div>
          </div>
        ))}
        <button type="submit" className="btn-solid-pearl" data-testid="admin-settings-save-btn"><Save size={15} className="mr-2" /> Save Settings</button>
        {saved && <p className="text-small" style={{ color: "var(--gg-logo-gold)" }} data-testid="admin-settings-saved">Settings saved.</p>}
      </form>
    </AdminPageShell>
  );
};

export default AdminSettings;
